import { personRef } from "@/content/author";
import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { getNewsletterIssueBySlug } from "@/lib/newsletter-public.functions";
import { pageTitle } from "@/lib/brand";
import { PageIntro, PageSection, WRAP } from "@/components/site/page";

export const Route = createFileRoute("/bulten/$slug")({
  loader: async ({ params }) => {
    const { issue } = await getNewsletterIssueBySlug({ data: { slug: params.slug } });
    if (!issue) throw notFound();
    return { issue };
  },
  head: ({ loaderData, params }) => {
    const subject = loaderData?.issue.subject ?? "Bülten";
    const url = `https://akillisurdurulebilirlik.com/bulten/${params.slug}`;
    const desc = `Akıllı Sürdürülebilirlik bülteni: ${subject}`;
    if (!loaderData) {
      return {
        meta: [
          { title: pageTitle("Bülten", "tr") },
          { name: "robots", content: "noindex" },
        ],
      };
    }
    return {
      meta: [
        { title: pageTitle(subject, "tr") },
        { name: "description", content: desc },
        { property: "og:title", content: subject },
        { property: "og:description", content: desc },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { property: "article:author", content: "Arda Öztaşkın" },
        { property: "article:published_time", content: loaderData.issue.sent_at },
      ],
      links: [{ rel: "canonical", href: url }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: subject,
            datePublished: loaderData.issue.sent_at,
            author: personRef(),
            publisher: { "@type": "Organization", name: "Akıllı Sürdürülebilirlik" },
            mainEntityOfPage: url,
            isPartOf: {
              "@type": "CreativeWorkSeries",
              name: "Akıllı Sürdürülebilirlik Bülteni",
              url: "https://akillisurdurulebilirlik.com/bulten",
            },
          }),
        },
      ],
    };
  },

  notFoundComponent: () => (
    <div className="mx-auto max-w-2xl px-5 py-20 text-center">
      <h1 className="font-serif text-3xl mb-4">Bülten bulunamadı</h1>
      <Link to="/" className="underline">Anasayfaya dön</Link>
    </div>
  ),
  errorComponent: () => (
    <div className="mx-auto max-w-2xl px-5 py-20 text-center">
      <p className="text-theme-tech">Bülten yüklenemedi.</p>
    </div>
  ),
  component: IssuePage,
});

function IssuePage() {
  const { issue } = Route.useLoaderData();
  const date = new Date(issue.sent_at).toLocaleDateString("tr-TR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  return (
    <>
      <PageIntro
        crumbs={[{ label: "Bülten", to: "/bulten" }, { label: issue.subject }]}
        kicker={date}
        title={issue.subject}
      />
      <PageSection>
        <iframe
          title={issue.subject}
          srcDoc={issue.html}
          sandbox=""
          className="w-full border border-ink/10 bg-paper"
          style={{ height: "80vh", minHeight: 600 }}
        />
      </PageSection>
    </>
  );
}
